(() => {
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
  if (window.__yurchakProductOnlySearch) return;
  window.__yurchakProductOnlySearch = true;
  const route = String(window.Shopify?.routes?.root || '/').replace(/\/$/,'') + '/search';
  const ensureProductOnly = root => {
    (root || document).querySelectorAll?.('form[action*="/search"]').forEach(form => {
      let input = form.querySelector('input[name="type"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'type';
        form.appendChild(input);
      }
      input.value = 'product';
    });
  };
  const normalizeCurrentSearch = () => {
    if (!/\/search\/?$/i.test(location.pathname)) return;
    const url = new URL(location.href);
    if (!url.searchParams.get('q') || url.searchParams.get('type') === 'product') return;
    url.searchParams.set('type','product');
    location.replace(url.toString());
  };
  const boot = () => { ensureProductOnly(document); normalizeCurrentSearch(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',event=>ensureProductOnly(event.target));
})();
